(($) => {
    /********************* Variables *************************/
    const downloadsAccordionHeader = $('.downloads-accordion__header');

    /********************* Functions *************************/
    const toggleAccordion = (e) => {
        downloadsAccordionHeader.not($(e.currentTarget)).parent().removeClass('active');
        downloadsAccordionHeader.not($(e.currentTarget)).parent().find('.downloads-accordion__content').slideUp(300);
        
        const target = $(e.currentTarget).parent();
        const content = target.find('.downloads-accordion__content');

        target.toggleClass('active');
        content.slideToggle(300);

        if(target.hasClass('active')){
            setTimeout(function(){
                let scroll_top_val = target.offset().top - 150;
                $('html').animate({
                    scrollTop: scroll_top_val
                }, 150);
            }, 300);
        }
    }

    /********************* Inits *************************/
    downloadsAccordionHeader.on('click', toggleAccordion);

})(jQuery);